
import { FirmaElectronicaService } from './../../../services/firma-electronica/firma-electronica.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort,DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { Observable } from 'rxjs/Rx';
import { startWith, map } from 'rxjs/operators';
import { FormControl, FormGroup} from '@angular/forms';
import { DatePipe} from "@angular/common";
import Swal from "sweetalert2";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { MessagesTitles, MessagesGeneral, MessagesDates } from '../../../models/messages';
import { SolicitudDesembolsoService } from '../../../services/operaciones/solicitud-desembolso/solicitud-des.service';
import { FiltrosSolicitudDes } from 'app/models/FiltrosSolicitudDes';
import { environment } from 'environments/environment';


export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "DD-MM-YYYY",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

declare var $: any;
@Component({
  selector: 'app-listado-solicitud-des',
  templateUrl: './listado-solicitud-des.component.html',
  styleUrls: ['./listado-solicitud-des.component.scss'],
  providers: [MessagesTitles,MessagesGeneral,MessagesDates,
    DatePipe,  
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class ListadoSolicitudDesComponent implements OnInit {

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  
  idSolicitudDesembolso: number = 0;
  user:any;

  flagNotificarSoliDes:boolean = false;
  notificarSoliDes : any;

  flagSoliDesDetalle:boolean = false;
  adjuntarPDF : boolean;
  fechaD: Date = new Date();
  fechaH: Date = new Date();
  ruc = new FormControl();
  rucAdq = new FormControl();
  TipoMoneda :any = [];
  idProv;
  idAdq;
  
  con:any=[];
  SolicitudDesembolso:any = [];

  form : FormGroup;
  formC: FormGroup;
  proveedoresArr;
  adquirentesArr;
  filteredProveeedor: Observable<any[]>;
  filteredAdquirentes: Observable<any[]>;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  pageSizeOptions = [15,20,30,50,100,200];
  loading:boolean;
  dataEnviarKeynua:any = {};

  displayedColumns: string[]=
  ['checked','idSolicitudDesembolso','idOperacion','Registro','pNomComercial','aNomComercial','Moneda','Adelanto_Importe','Desembolso_Importe','Estado','Adjunto_PDF_Firmado']

  dataSource : any;
  DTOFiltrosSolicitudDes: FiltrosSolicitudDes = new FiltrosSolicitudDes();
constructor(private solicitudDesembolsoService:SolicitudDesembolsoService,
            private datePipe:DatePipe,
            private firmaElectronicaService:FirmaElectronicaService){
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.fechaD.setDate(this.fechaD.getDate()-60);
    this.ObtenerProveedorCombo();
    this.ObtenerAdquirentesCombo();
}

ngOnInit() {
    this.ListadoSoliDesFiltros();
}

tipoMoneda(event){
  if(event==''){
    this.DTOFiltrosSolicitudDes.Moneda="0";
  }else{ 
    this.DTOFiltrosSolicitudDes.Moneda = event;
  }  
}

 private _filterProv(value:string):any[]{
     const filterValue = value.toString().toLowerCase();

     return this.proveedoresArr.filter(
         state => state.Razon_Social.toLowerCase().includes(filterValue) === true
     )
 }

 ObtenerProveedorCombo(){
     this.proveedoresArr = JSON.parse(sessionStorage.getItem('lstProvCbo'));
     this.filteredProveeedor = this.ruc.valueChanges
     .pipe(
         startWith(""),
         map(state =>
            state ? this._filterProv(state) : this.proveedoresArr.slice()
        )
     ); 
 }
 
 obtenerIdProv(termino:string){
    this.idProv = termino;
    this.DTOFiltrosSolicitudDes.IdProv = termino;
 }

 EnteroObtenerRucRazSocialProv(termino:string = ''){
     if(termino != null && termino != ''){
         let termino1 = termino.toLowerCase();
         for(let p of this.proveedoresArr){
             let raz = p.Razon_Social.toLocaleLowerCase();
          if(raz.indexOf(termino1) >=0){
              this.idProv = p.idEmpresa;
              this.DTOFiltrosSolicitudDes.IdProv = p.idEmpresa;
          }
        }
    }
}

private _filterAdq(value:string):any[]{
    const filterValue = value.toString().toLowerCase();
    return this.adquirentesArr.filter(
        state => state.Razon_Social.toLowerCase().includes(filterValue) === true
    )
}

ObtenerAdquirentesCombo() {
    this.adquirentesArr = JSON.parse(sessionStorage.getItem('lstAdqCbo'));   
    this.filteredAdquirentes = this.rucAdq.valueChanges
    .pipe(
      startWith(""),
      map(state =>
        state ? this._filterAdq(state) : this.adquirentesArr.slice()
      )
    );
 
}

obtenerIdAd(terminoAD :string){
    this.idAdq = terminoAD;
    this.DTOFiltrosSolicitudDes.IdAd = terminoAD;
}

obtenerAdRazSocial(terminoAD :string = ''){

    if (terminoAD != null && terminoAD != ''){
      
      let terminoAD1 = terminoAD.toLowerCase();                   
  
      for( let a of this.adquirentesArr){
  
          let raz = a.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(terminoAD1)  >= 0){
            
            this.idAdq = a.idEmpresa;
            this.DTOFiltrosSolicitudDes.IdAd = a.idEmpresa;
        }
  
    }
}
}


ListadoSoliDesFiltros(){

    this.loading = true;
    if (this.ruc.value == null || this.ruc.value == ""){
        this.idProv = "";
        this.DTOFiltrosSolicitudDes.IdProv = ""}
     if (this.rucAdq.value == null || this.rucAdq.value == ""){
        this.idAdq="";
        this.DTOFiltrosSolicitudDes.IdAd="";
    }
    this.solicitudDesembolsoService.FiltroListadoSoliDes(this.DTOFiltrosSolicitudDes,this.datePipe.transform(this.fechaD,'yyyy-MM-dd'),this.datePipe.transform(this.fechaH,'yyyy-MM-dd'))
    .subscribe(
        res =>{
            this.SolicitudDesembolso = res;
            this.dataSource = new MatTableDataSource( this.SolicitudDesembolso);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
            this.loading = false;
        },err =>{
            Swal.fire({
                title: "¡Algo salió mal!",
                text:  err.error['error'],
                type: "warning",
                allowOutsideClick: true,
                heightAuto: false 
            });
            this.loading = false;
        }
    )
}

cargarListadoCompleto(){
    this.loading = true;
    this.solicitudDesembolsoService.FiltroListadoSoliDes(this.DTOFiltrosSolicitudDes,this.datePipe.transform(this.fechaD,'dd-MM-yyyy'),this.datePipe.transform(this.fechaH,'yyyy-MM-dd'))
    .subscribe(res=>{
      this.SolicitudDesembolso = res;
      this.loading = false;

      this.dataSource = new MatTableDataSource(this.SolicitudDesembolso);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });
  }

  enviaridSolicitudDesembolso(idSolicitudDesembolso:any){
    this.idSolicitudDesembolso = idSolicitudDesembolso;
    this.flagSoliDesDetalle = true;
  }

  MetcerrarSoliDesDetalle(){
    this.flagSoliDesDetalle  = false;
  }

  anularSolicitudDesembolso(idSolicitudDesembolso){
    Swal.fire({
      title:'',
      text:'¿Estás seguro en dar de baja la solicitud de desembolso?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText:'Si,dar de baja.',
      cancelButtonText: 'No,Cancelar.',
      reverseButtons: true,
      heightAuto: false
    }).then((result)=>{
      if(result.value){
        Swal.fire({
          title: '¡Espere!',
          html: 'Procesando solicitud.',
          heightAuto: false
        })
        Swal.showLoading();
        this.form = new FormGroup({
          'idSolicitudDesembolso' : new FormControl(idSolicitudDesembolso),
          'Estado' : new FormControl('B'),
          'Baja_Canal': new FormControl('W'),
          'Baja_Usuario': new FormControl(this.user.Usuario) 
        })
        
        this.solicitudDesembolsoService.anularSolicitudDesembolso(this.form.getRawValue()).subscribe( 
          res =>{
            //this.actualizarEstado(idSolicitudDesembolso)
            this.ListadoSoliDesFiltros();
            Swal.fire({
              title: '¡Éxito',
              text: 'La Solicitud de Desembolso ha sido dado de baja exitosamente.',
              type: 'success',
              heightAuto: false
          });
        }, err => {
          Swal.fire({
            title: "Error",
            text: "No se pudo dar de baja la Solicitud de Desembolso.",
            type: "error",
            allowOutsideClick: false,
            heightAuto: false
          });
        })
        
      }
    })
  }

  enviarSolicitudDesembolsoKeynua(idSolicitudDesembolso :any,idOperacion : any){
    Swal.fire({
      title: 'Enviar solicitud desembolso a Keynua',
      text: '¿Desea enviar solicitud desembolso a keynua.?',
      type: "info",
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si',
      cancelButtonText: 'No',
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        this.dataEnviarKeynua.idSolicitudDesembolso = idSolicitudDesembolso;
        this.dataEnviarKeynua.idOperacion = idOperacion;
        this.enviarSolicitudDesembolsoElectronico(this.dataEnviarKeynua);
      }
    });
  }

  enviarSolicitudDesembolsoElectronico(dataEnviarKeynua){
   Swal.fire({
    title: 'Espere',
    text: 'Enviando solicitud desembolso a keynua.',
    type: 'info',
    heightAuto: false
   });
  Swal.showLoading();
   this.firmaElectronicaService.enviarSolicitudDesElectronico(dataEnviarKeynua).subscribe(
       res => {  
        Swal.close();     
         this.ListadoSoliDesFiltros();
         this.showNotification('success','top','right','Documento enviado satisfactoriamente para su firma digital.');
       },err => {
        if (err.error.message) {
         this.showNotification('warning','top','right','No se pudo enviar solicitud desembolso a keynua. \n Error: ' + err.error.message);
        }else{
         let error = "";
         error = err.error.error;
         this.showNotification('warning','top','right','No se pudo enviar solicitud desembolso a keynua. \n Error: ' + error);
        }
      
      }
   );
 }

  notificarCorreo(element: any){
    this.flagNotificarSoliDes = true;
    this.notificarSoliDes = element;
  }

  obtenerpdf($file:any){
    window.open($file,"_blank");
  }

  CerrarPopUpnotificarCorreo(click:boolean){
    this.flagNotificarSoliDes= false;
    this.ListadoSoliDesFiltros();
 }

 altaSolicitudDesembolso(element:any){
  this.solicitudDesembolsoService.dataSolicitudD = element;  
  this.adjuntarPDF = true;

}
 cerrarPopUpFirmado(){
  this.adjuntarPDF = false;
 }

  showNotification(type,from,align,message){
    //const type = ['','info','success','warning','danger']; => tipo de notificacion
    //from = [Top,bottom,etc] => orientacion vertical
    //align = center, left, right => orientacion horizontal
    $.notify({
        icon: "notifications",
        message: message
    },{
        type: type,
        timer: 4000,
        placement: {
            from: from,
            align: align
        },
        template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
          '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
          '<i class="material-icons" data-notify="icon">notifications</i> ' +
          '<span data-notify="title">{1}</span> ' +
          '<span data-notify="message">{2}</span>' +
          '<div class="progress" data-notify="progressbar">' +
            '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
          '</div>' +
          '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>'
    });
  }

  
}